export default __webpack_public_path__ + "media/images/work_with_us/work_hero_lg-b046d09fe28812f41c80124c78ac839c.webp";